// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getAuth } from "firebase/auth";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyAjoN9h5FljULI0AfplmrdiyPc0SU9rHr0",
  authDomain: "mintyfloss-1df25.firebaseapp.com",
  projectId: "mintyfloss-1df25",
  storageBucket: "mintyfloss-1df25.firebasestorage.app",
  messagingSenderId: "158365335557",
  appId: "1:158365335557:web:d3d9279be9586c898e5c6c",
  measurementId: "G-QQVSW24MVT"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);  

export const auth = getAuth(app);